import { GET_CARRUSEL, GET_LEVELS } from 'constants/api'
import axios, { AxiosError } from 'axios'
import ButtonNav from 'components/button-nav'
import GoArrow from 'components/icon/goArrow'
import LineSteps from 'components/line-steps'
import { LoaderContext } from 'contexts/loader-context'
import { useSession } from 'contexts/session-context'
import UsePercentageProfile from 'hooks/use-percentage-profle'
import useRouter from 'hooks/use-router'
import { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'
import textServices from 'services/text-services'
import { DivProgress, DivProgressSecond } from 'theme/home'
import PopUp from './components/PopUp'
import { Dots, HrHome, Points } from './style/home.style'
import { TextHomeSecondary, TitleHome } from './style/text.style'

const Type = { 1: 'onclick', 2: 'href', 3: 'to' }

function Home() {
  const [{ user, data: session }] = useSession()
  const { percentageProfile } = UsePercentageProfile()
  const { setLoad } = useContext(LoaderContext)
  const { push } = useRouter()
  const [carrousel, setCarrusel] =
    useState<{ src: string; to?: string; href?: string; id: number; onclick?: string }[]>()
  const [asyncSteps, setAsyncSteps] = useState<{ id: number; name: string; imageUrl: string }[]>([])
  const [steps, setSteps] = useState<{ name: string; image: string; active?: boolean }[]>([])
  const [popUp, setPopUp] = useState<string | number>()

  const getAsyncStates = async () => {
    setLoad(true)
    try {
      const { data: steps } = await axios.get<{ id: number; name: string; imageUrl: string }[]>(GET_LEVELS, {
        headers: { Authorization: `Bearer ${((session as any)?._tokenResponse as any)?.idToken}` }
      })
      if (steps.length > 0) {
        setAsyncSteps(steps)
      }
      const { data: carrousel } = await axios.get<{ imageUrl: string; type: number; url: string }[]>(GET_CARRUSEL)
      if (carrousel.length > 0) {
        setCarrusel(
          carrousel.map(({ imageUrl, type, url }, index) => ({
            src: imageUrl,
            [Type[type] ?? 'href']: url,
            id: index
          }))
        )
      }
      setLoad(false)
    } catch (error) {
      const err = error as AxiosError
      const code = err.response?.data.code || 99999
      setLoad(false)
      push(`/error/${code}`)
    } finally {
      setLoad(false)
    }
  }

  useEffect(() => {
    if (asyncSteps?.length > 0) {
      setSteps(
        asyncSteps?.map(({ id, name, imageUrl }) => ({
          id,
          name,
          image: imageUrl,
          active: id === user?.level?.id
        }))
      )
    }
  }, [user, asyncSteps])

  useEffect(() => {
    getAsyncStates()
    return () => {
      setCarrusel([])
      setSteps([])
    }
  }, [])

  const dots = () => <Dots></Dots>

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    customPaging: dots,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
  }

  if (popUp) {
    return <PopUp popUp={popUp} setPopUpFalse={() => setPopUp(undefined)} />
  }

  return (
    <div className={`py-7 px-7 flex flex-col w-full ${THEME_CONFIG?.usePoints ? 'gap-4 ' : 'gap-7'}`}>
      <div className="text-3xl uppercase">
        <TitleHome className="font-black leading-5">Hola {user?.firstName}</TitleHome>
        <TitleHome>{textServices.findByText('home/title', '¿Qué quieres hacer?')}</TitleHome>
      </div>
      <nav className="flex flex-row items-center gap-4 justify-between">
        {THEME_CONFIG.routesHome.map((route: string, index: number) => (
          <ButtonNav key={index} route={route} />
        ))}
      </nav>{' '}
      {(THEME_CONFIG?.usePoints) && (
        <>
          <HrHome />
          <section className="gap-2 flex flex-col items-center justify-center">
            <div className="flex items-center justify-between w-full">
              <TitleHome className="font-black text-2xl flex-1 text-left uppercase">
                Tienes{' '}
                <Points>
                  {user?.totalPoints} {POINTS_NAME}
                </Points>
              </TitleHome>
              {/* <Link to={'/progress'}> */}
              <img src={user?.level?.imageUrl} alt={user?.level?.name} className="w-10" />
              {/* </Link> */}
            </div>
            <LineSteps steps={steps} />
          </section>{' '}
        </>
      )}
      <HrHome />
      <section className="gap-2 flex flex-col items-center justify-center">
        <Link to="/profile" className="w-full">
          <div className="flex items-center justify-between w-full">
            <TextHomeSecondary className="font-normal text-base flex-1 text-left">
              {textServices.findByText('home/description', '¡Completa tus datos!')}
            </TextHomeSecondary>
            <GoArrow />
          </div>
        </Link>
        <DivProgress className="w-full h-7 rounded-full relative flex items-center">
          <DivProgressSecond
            className="w-full h-full bg-left rounded-full relative"
            style={{ width: `${percentageProfile}%` }}
          >
            <span className="absolute right-4 h-full flex items-center">{percentageProfile}% {percentageProfile > 30 && textServices.findByText('home/percentageProfile', '')}</span>
          </DivProgressSecond>
        </DivProgress>
      </section>
      <HrHome />
      <section className="w-full relative h-52">
        <Slider {...settings} className="w-full h-52">
          {carrousel?.map(({ src, to, href, id, onclick }) => {
            if (href)
              return (
                <a href={href} key={id} target="_blank" rel="noreferrer">
                  <img src={src} alt="carrusel" className="w-full h-52 object-cover rounded-xl cursor-pointer" />
                </a>
              )
            if (to) {
              return (
                <Link to={to} key={id}>
                  <img src={src} alt="carrusel" className="w-full h-52 object-cover rounded-xl cursor-pointer" />
                </Link>
              )
            }
            return (
              <img
                className="h-52 rounded-xl w-full object-cover cursor-pointer"
                src={src}
                key={id}
                onClick={() => {
                  gtag('event', 'Click', {
                    event_category: GTM_EVENT_CATEGORY,
                    event_label: 'HOME - Ver mas informacion del carrousel',
                    value: '10'
                  })
                  setPopUp(onclick)
                }}
              />
            )
          })}
        </Slider>
      </section>
    </div>
  )
}

export default Home
